import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { CalendarDays, Clock, MapPin, ListChecks } from 'lucide-react';

/**
 * Affiche le programme (déroulé) d'un événement.
 * Le programme est saisi en texte libre, une étape par ligne — on le rend
 * sous forme de liste à puces pour une lecture façon « agenda ».
 *
 * Réutilisé par la page Événements et la carte « Prochain événement » de l'Accueil.
 */
export function EventProgramDialog({ event, open, onOpenChange }) {
  if (!event) return null;

  const date = event.date ? new Date(event.date) : null;
  const steps = (event.program || '')
    .split('\n')
    .map((l) => l.trim())
    .filter(Boolean);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <ListChecks className="h-5 w-5 text-primary" />
            Programme — {event.title}
          </DialogTitle>
          <DialogDescription className="flex flex-wrap items-center gap-x-3 gap-y-1">
            {date && (
              <span className="inline-flex items-center gap-1.5 capitalize">
                <CalendarDays className="h-3.5 w-3.5" />
                {date.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
              </span>
            )}
            {date && (
              <span className="inline-flex items-center gap-1.5">
                <Clock className="h-3.5 w-3.5" />
                {date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
              </span>
            )}
            {event.location && (
              <span className="inline-flex items-center gap-1.5">
                <MapPin className="h-3.5 w-3.5" />
                {event.location}
              </span>
            )}
          </DialogDescription>
        </DialogHeader>

        {steps.length > 0 ? (
          <ol className="space-y-2.5 py-1">
            {steps.map((line, i) => (
              <li key={i} className="flex gap-3">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary/60" />
                <span className="text-sm leading-relaxed">{line}</span>
              </li>
            ))}
          </ol>
        ) : (
          <div className="py-10 text-center">
            <ListChecks className="mx-auto mb-3 h-10 w-10 text-muted-foreground/40" />
            <p className="text-sm text-muted-foreground">
              Le programme n'a pas encore été publié pour cet événement.
            </p>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default EventProgramDialog;
